document.addEventListener('DOMContentLoaded', function () {
  this.slider = document.querySelector('[id^="Slider-"]');
  this.sliderItems = document.querySelectorAll('[id^="Slide-"]');
  this.initialSlides = document.querySelectorAll('[id^="Slide-"]');
  this.enableSliderLooping = false;
  this.currentPageElement = document.querySelector(".slider-counter--current");
  this.pageTotalElement = document.querySelector(".slider-counter--total");
  this.prevButton = document.querySelectorAll('button[name="previous"]');
  this.nextButton = document.querySelectorAll('button[name="next"]');
  this.scrollPos = this.slider.scrollLeft;
  this.sliderItemOffset = this.sliderItems[1].offsetLeft - this.sliderItems[0].offsetLeft;

  if (!this.slider || !this.nextButton) return;

  this.prevButton.forEach(button => {
    button.addEventListener("click", onButtonClick.bind(this));
  });

  this.nextButton.forEach(button => {
    button.addEventListener("click", onButtonClick.bind(this));
  });

  function onButtonClick(event) {
    event.preventDefault();
    this.elementAdded = true;
    const step = event.currentTarget.dataset.step || 1;
    const isNext = event.currentTarget.name === "next";
    this.slideScrollPosition = isNext ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
});
